import React from "react";

export function VegBadge({ veg, className = "" }) {
  return <span className={`${veg ? "veg-badge" : "nonveg-badge"} ${className}`} title={veg ? "Veg" : "Non-Veg"} data-testid={veg ? "veg-badge" : "nonveg-badge"} />;
}
